// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*DESKTOP*/
@media screen and (min-width:1024px) {
    .Lista_container__Ixz10 {
        display: flex;
        place-content: center;
        text-transform: capitalize;
    }

    .Lista_container__Ixz10>div {
        width: 95%;
        margin-top: 20px;
    }

    .Lista_options__Y80fR {
        display: flex;
        place-content: center;
    }
}

/*TABLET*/
@media screen and (min-width:767px) and (max-width:1024px) {
    .Lista_container__Ixz10 {
        display: flex;
        place-content: center;
        text-transform: capitalize;
    }

    .Lista_container__Ixz10>div {
        width: 95%;
        margin-top: 20px;
    }

    .Lista_options__Y80fR {
        display: flex;
        place-content: center;
    }
}

/*MOBILE*/
@media screen and (max-width:767px) {
    .Lista_container__Ixz10 {
        display: flex;
        place-content: center;
        text-transform: capitalize;
    }

    .Lista_container__Ixz10>div {
        width: 95%;
        margin-top: 5px;
    }

    .Lista_options__Y80fR {
        display: flex;
        place-content: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/lista/Lista.module.css"],"names":[],"mappings":"AAAA,UAAU;AACV;IACI;QACI,aAAa;QACb,qBAAqB;QACrB,0BAA0B;IAC9B;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,qBAAqB;IACzB;AACJ;;AAEA,SAAS;AACT;IACI;QACI,aAAa;QACb,qBAAqB;QACrB,0BAA0B;IAC9B;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,qBAAqB;IACzB;AACJ;;AAEA,SAAS;AACT;IACI;QACI,aAAa;QACb,qBAAqB;QACrB,0BAA0B;IAC9B;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,qBAAqB;IACzB;AACJ","sourcesContent":["/*DESKTOP*/\n@media screen and (min-width:1024px) {\n    .container {\n        display: flex;\n        place-content: center;\n        text-transform: capitalize;\n    }\n\n    .container>div {\n        width: 95%;\n        margin-top: 20px;\n    }\n\n    .options {\n        display: flex;\n        place-content: center;\n    }\n}\n\n/*TABLET*/\n@media screen and (min-width:767px) and (max-width:1024px) {\n    .container {\n        display: flex;\n        place-content: center;\n        text-transform: capitalize;\n    }\n\n    .container>div {\n        width: 95%;\n        margin-top: 20px;\n    }\n\n    .options {\n        display: flex;\n        place-content: center;\n    }\n}\n\n/*MOBILE*/\n@media screen and (max-width:767px) {\n    .container {\n        display: flex;\n        place-content: center;\n        text-transform: capitalize;\n    }\n\n    .container>div {\n        width: 95%;\n        margin-top: 5px;\n    }\n\n    .options {\n        display: flex;\n        place-content: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Lista_container__Ixz10`,
	"options": `Lista_options__Y80fR`
};
export default ___CSS_LOADER_EXPORT___;
